export enum QUERY_KEYS {
  bulkImportPassHolders = 'bulk-import-pass-holders',
}
